module.exports = __webpack_public_path__ + "public/media/bim.91f1741f.mp4";